// Keyword-targeted SEO landing page content for organic Google traffic.
const HERO = "https://images.unsplash.com/photo-1584598416417-84bd357908ef?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";
const FPV = "https://images.unsplash.com/photo-1577533870320-2c31e7e41028?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";
const CTRL = "https://images.unsplash.com/photo-1469313785555-277fa0c1dc9e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";
const BASIC = "https://images.unsplash.com/photo-1545864968-f6031e1790c2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export const SEO_PAGES = {
  "faa-part-107-course": {
    keyword: "FAA Part 107 Course",
    title: "FAA Part 107 Course Online — Pass Your Remote Pilot Exam | DronAcademy",
    description:
      "Prepare for the FAA Part 107 exam online with DronAcademy. Airspace, weather, regulations, METARs and practice quizzes — plus an AI instructor. Pass your Remote Pilot Certificate.",
    image: HERO,
    overline: "FAA Part 107 Exam Prep",
    h1: "The online FAA Part 107 course that gets you certified",
    subhead:
      "Everything you need to pass the FAA Part 107 Remote Pilot knowledge test — airspace classes, aviation weather, sectional charts, regulations and hundreds of practice questions.",
    benefits: [
      "Complete Part 107 curriculum: airspace, weather, METARs, regulations",
      "Unlimited practice quizzes with instant scoring (70% to pass)",
      "AI instructor 'Skyler' answers your exam questions 24/7",
      "Learn on any device — lifetime access for one payment",
    ],
    learn: [
      { t: "Airspace Classes", d: "Read sectional charts and identify Class B–G airspace and LAANC requirements." },
      { t: "Aviation Weather", d: "Decode METARs, understand density altitude and go/no-go decisions." },
      { t: "Regulations", d: "Master Part 107 rules: altitude limits, VLOS, waivers and operating limitations." },
      { t: "Exam Strategy", d: "Practice with realistic questions and track your readiness to 100%." },
    ],
    faqs: [
      { q: "What score do I need to pass the FAA Part 107 exam?", a: "You need 70% — 42 of 60 questions correct — to pass the Remote Pilot knowledge test." },
      { q: "How long does it take to prepare?", a: "Most students are exam-ready in 1–3 weeks using our structured lessons and practice quizzes." },
      { q: "Is this course good for beginners?", a: "Yes. DronAcademy teaches from fundamentals up to certification, so no prior experience is needed." },
    ],
  },
  "how-to-fly-a-drone": {
    keyword: "How to Fly a Drone",
    title: "How to Fly a Drone: Step-by-Step Beginner Course | DronAcademy",
    description:
      "Learn how to fly a drone the right way. Master throttle, yaw, pitch and roll, safe pre-flight checks and your first hover with DronAcademy's interactive online course.",
    image: CTRL,
    overline: "Beginner Flight Guide",
    h1: "How to fly a drone — from first hover to confident pilot",
    subhead:
      "A step-by-step, hands-on course covering the sticks (throttle, yaw, pitch, roll), stable hovering, core maneuvers and the safety habits every pilot needs.",
    benefits: [
      "Understand every control channel on a Mode 2 transmitter",
      "Guided drills: stable hover, box pattern and figure-8",
      "Pre-flight checklists and emergency procedures",
      "Demonstration videos on every lesson",
    ],
    learn: [
      { t: "The Four Channels", d: "Throttle, yaw, pitch and roll explained with clear visuals." },
      { t: "Your First Hover", d: "Hold a stable hover and trim out drift with confidence." },
      { t: "Core Maneuvers", d: "Fly the box pattern and figure-8 to build muscle memory." },
      { t: "Fly Safely", d: "Pre-flight checks, weather awareness and return-to-home." },
    ],
    faqs: [
      { q: "Is flying a drone hard to learn?", a: "With structured drills most beginners can hold a stable hover within their first few sessions. Our course builds skills step by step." },
      { q: "Do I need my own drone to start?", a: "No — you can learn all the theory and controls first, then practice on any drone you own." },
      { q: "What's the most common beginner mistake?", a: "Over-controlling the sticks. We teach smooth, small inputs so your drone stays stable." },
    ],
  },
  "learn-drone-flying-online": {
    keyword: "Learn Drone Flying Online",
    title: "Learn Drone Flying Online — Interactive Course & AI Instructor | DronAcademy",
    description:
      "Learn drone flying online at your own pace. Interactive lessons, quizzes, progress tracking, achievement badges and a 24/7 AI flight instructor. Start free today.",
    image: HERO,
    overline: "Online Flight School",
    h1: "Learn drone flying online — reimagined",
    subhead:
      "Interactive lessons, hands-on control drills, an AI flight instructor and full FAA Part 107 prep. Everything from first hover to commercial certification, on any device.",
    benefits: [
      "4 structured modules with 12+ lessons and demo videos",
      "AI instructor 'Skyler' for instant, personalized coaching",
      "Progress tracking, quiz scoring and achievement badges",
      "Learn anywhere — lifetime access for a single payment",
    ],
    learn: [
      { t: "Drone Basics", d: "Anatomy, lift, motors, props and battery safety." },
      { t: "Flight Controls", d: "Master the sticks and essential maneuvers." },
      { t: "Safety & Pre-Flight", d: "Checklists, weather and emergency procedures." },
      { t: "FAA Part 107", d: "Full certification exam prep and practice quizzes." },
    ],
    faqs: [
      { q: "Can I really learn to fly a drone online?", a: "Yes. Our interactive lessons, videos and AI instructor teach the theory, controls and safety you need before and during real flights." },
      { q: "How much does the course cost?", a: "Ground School is free to start right now — create an account and begin your first lesson at no cost. Pricing for the full course will be announced soon." },
      { q: "Is there anything for exam prep?", a: "Yes — a complete FAA Part 107 module with practice quizzes to get you certified." },
    ],
  },
  "drone-training-for-beginners": {
    keyword: "Drone Training for Beginners",
    title: "Drone Training for Beginners — Start Flying Confidently | DronAcademy",
    description:
      "Beginner drone training made simple. Learn drone parts, controls, safe flying and pre-flight checklists with guided lessons and an AI instructor. Start free with DronAcademy.",
    image: BASIC,
    overline: "Beginner Friendly",
    h1: "Drone training for beginners that actually clicks",
    subhead:
      "New to drones? Start here. We break down how drones work, how to control them and how to fly safely — with plain-English lessons and demonstration videos.",
    benefits: [
      "Zero jargon — designed for complete first-time flyers",
      "Learn drone anatomy, lift and battery care",
      "Build real skills with guided control drills",
      "Grow all the way to FAA Part 107 certification",
    ],
    learn: [
      { t: "How Drones Work", d: "Motors, props, ESCs and flight controllers explained simply." },
      { t: "Controls 101", d: "Throttle, yaw, pitch and roll with hands-on drills." },
      { t: "Safe Flying", d: "Pre-flight checks, weather and where you can legally fly." },
      { t: "Next Steps", d: "Progress into maneuvers and Part 107 certification." },
    ],
    faqs: [
      { q: "I've never flown before — is this right for me?", a: "Absolutely. The course is built for complete beginners and starts from the very fundamentals." },
      { q: "How long until I can fly confidently?", a: "Most beginners gain confident hovering and basic maneuver skills within a couple of weeks of practice." },
      { q: "Will this help me fly legally?", a: "Yes — we cover safety, airspace and the FAA Part 107 rules for flying legally in the US." },
    ],
  },
};

export const SEO_SLUGS = Object.keys(SEO_PAGES);
